"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormGroup = _interopRequireDefault(require("@mui/material/FormGroup"));
var _FormControlLabel = _interopRequireDefault(require("@mui/material/FormControlLabel"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _ = require("..");
var Theme = _interopRequireWildcard(require("../theme"));
var _i18n = _interopRequireDefault(require("../localization/i18n"));
var _tokens = _interopRequireDefault(require("../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Services and Themes

// Localization

/**
 * 
 */
var DisplayBankingDetails = function DisplayBankingDetails(_ref) {
  var accountHolder = _ref.accountHolder,
    accountNum = _ref.accountNum,
    institutionAddress = _ref.institutionAddress,
    institutionName = _ref.institutionName,
    institutionNum = _ref.institutionNum,
    transitNum = _ref.transitNum,
    accepted = _ref.accepted,
    acceptedBankingTermsError = _ref.acceptedBankingTermsError;
  var styles = {
    gridStyle: {
      padding: "8px",
      flex: 1
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    medium: true,
    margin: "10px 0px 0px 0px",
    bold: true
  }, _i18n["default"].t(_tokens["default"].labels.banking.ensureDepositInformationIsCorrect))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.MessageCard, {
    title: institutionName,
    subtitle: institutionAddress
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.masterApplication.name), ": ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, accountHolder))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.banking.financialInstitutionNumber), ": ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, institutionNum))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.banking.branchTransitNumber), ": ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, transitNum))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    sx: styles.gridStyle,
    xs: 12
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    medium: true
  }, _i18n["default"].t(_tokens["default"].labels.banking.accountNumber), ": ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: Theme.colors.black,
      fontWeight: 'bold'
    }
  }, accountNum))), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    error: Boolean(acceptedBankingTermsError)
  }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    fullWidth: true
  }, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    row: true,
    style: {
      marginTop: 20,
      marginBottom: 20
    }
  }, /*#__PURE__*/_react["default"].createElement(_FormControlLabel["default"], {
    error: acceptedBankingTermsError,
    control: /*#__PURE__*/_react["default"].createElement(_.Checkbox, {
      checked: accepted,
      value: "bankingAcceptedTerms",
      disabled: true,
      color: "secondary"
    }),
    label: /*#__PURE__*/_react["default"].createElement(_.Text, {
      avMedium: true
    }, _i18n["default"].t(_tokens["default"].labels.banking.legalAccessVerbiageAccount))
  })), acceptedBankingTermsError && /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
    sx: {
      marginLeft: "0px"
    },
    error: true
  }, _i18n["default"].t(_tokens["default"].labels.banking.youMustAcceptTermsError)))));
};
var _default = exports["default"] = DisplayBankingDetails;